var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'fill-height ' + (_vm.isDesktopView ? '' : 'pa-0')},[(_vm.isDesktopView)?_c('ObjectPageDesktop'):_c('ObjectPageMobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }